import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg width="22" height="12" viewBox="0 0 22 12" xmlns="http://www.w3.org/2000/svg" {...this.props}><path d="M0 7h22V5H0v2zm0 5h22v-2H0v2zM0 2h22V0H0v2z" fillRule="evenodd" /></svg>;
  }

}


// WEBPACK FOOTER //
// ./src/static/images/menu.svg